/* eslint-disable max-lines-per-function */
import { cn } from "tailwind-variants";
import { useDtfStore } from "../store";
import "./LettersFont.scss";
import { renderList } from "common/vue/render-list";

export default function LettersFont({ fonts, ...restProps }) {
  const store = useDtfStore();

  function letterNumberArtwork() {
    return store.letterNumberArtwork;
  }

  function handleSelect(option) {
    const font = option.value;
    store.updateArtworkValues({
      index: 0,
      font
    });
    store.updateAllLetterPreviews();
  }

  return (
    <div {...restProps} className={cn("letters-font", restProps.className)}>
      {renderList(fonts, font => (
        <div
          className={cn(
            "letters-font__item",
            letterNumberArtwork().font === font.value && "letters-font__item--selected"
          )}
          key={font.value}
          onClick={() => {
            handleSelect(font);
          }}
          data-testid="letters-font-div"
        >
          <div className={cn("letters-font__text", `letters-font__text--${font.value}`)}>
            {" "}
            ABCD{" "}
          </div>
          <span className="letters-font__label">{font.label}</span>
        </div>
      ))}
    </div>
  );
}
